import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import ClientesView from "@/Clientes";
import GaleriaView from "@/Galeria";
import LeadsView from "@/Leads";
import LeadForm from "@/LeadForm";
import LoginModal from "@/LoginModal";
import AgendaView from "@/Agenda";
import GalleryPreview from "@/GalleryPreview";
import ReviewsSection from "@/Reviews";
import ReviewsAdminView from "@/ReviewsAdmin";
import VirtualTour from "@/VirtualTour";
import PlanosVeraoSection from "@/PlanosVerao";
import HyroxSection from "@/HyroxSection";
import PromoBanner from "@/PromoBanner";
import { useAuth } from "@/AuthContext";
import {
  Dumbbell,
  Flame,
  Activity,
  StretchHorizontal,
  Baby,
  HeartPulse,
  Trophy,
  Gem,
  TrendingDown,
  Home as HomeIcon,
  TreePine,
  Layers,
  Loader2,
  Save,
  Trash2,
  History,
  Sparkles,
  ArrowRight,
  Clock,
  User,
  Users,
  UsersRound,
  ShieldCheck,
  Repeat,
  Euro,
  Tag,
  Coffee,
  Droplets,
  Music,
  Sparkle,
  LogIn,
  LogOut,
  Inbox,
  PersonStanding,
  Calendar as CalendarNavIcon,
  Menu,
  X as XIcon,
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const OBJETIVOS = [
  { id: "ganho_muscular", label: "Ganho Muscular", icon: Dumbbell },
  { id: "perda_peso", label: "Perda de Peso", icon: TrendingDown },
  { id: "perda_gordura", label: "Perda de Gordura", icon: Flame },
  { id: "tonificacao", label: "Tonificação", icon: Gem },
  { id: "resistencia", label: "Resistência", icon: Activity },
  { id: "mobilidade", label: "Mobilidade", icon: StretchHorizontal },
  { id: "pre_parto", label: "Pré-Parto", icon: Baby },
  { id: "pos_parto", label: "Pós-Parto", icon: HeartPulse },
  { id: "jovens_atletas", label: "Jovens Atletas", icon: Trophy },
  { id: "senior_60", label: "Sénior +60 · Força & Resistência", icon: PersonStanding },
];

const NIVEIS = [
  { id: "iniciante", label: "Iniciante" },
  { id: "intermedio", label: "Intermédio" },
  { id: "avancado", label: "Avançado" },
];

const ZONAS = [
  { id: "interior", label: "Interior · 45 m²", icon: HomeIcon },
  { id: "exterior", label: "Exterior · 20 m²", icon: TreePine },
  { id: "ambas", label: "Ambas as zonas", icon: Layers },
];

const labelObjetivo = (id) => OBJETIVOS.find((o) => o.id === id)?.label || id;
const labelNivel = (id) => NIVEIS.find((n) => n.id === id)?.label || id;
const labelZona = (id) => ZONAS.find((z) => z.id === id)?.label || id;

function Header({ view, setView, onHistoryClick, onPricingClick, onLoginClick, onContactClick }) {
  const { authed, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const tabBase =
    "text-xs uppercase tracking-widest font-bold transition-colors px-3 py-2";

  const closeMenu = () => setMenuOpen(false);
  const go = (v) => {
    setView(v);
    closeMenu();
  };
  const goPricing = () => { onPricingClick(); closeMenu(); };
  const goContact = () => { onContactClick(); closeMenu(); };
  const goHistory = () => { onHistoryClick(); closeMenu(); };
  const doLogin = () => { onLoginClick(); closeMenu(); };
  const doLogout = () => { logout(); closeMenu(); };

  return (
    <header
      className="sticky top-0 z-40 border-b border-neutral-900 bg-[#050505]/90 backdrop-blur"
      data-testid="site-header"
    >
      <div className="px-6 md:px-12 lg:px-24 h-16 flex items-center justify-between gap-4">
        <button
          onClick={() => setView("home")}
          className="flex items-center gap-2 shrink-0"
          data-testid="brand-link"
        >
          <div className="w-2.5 h-2.5 bg-yellow-400" />
          <span
            className="font-display text-2xl uppercase tracking-tight"
            data-testid="brand-logo"
          >
            <span className="text-yellow-400">O</span>-MEU-PT<span className="text-yellow-400">.PT</span>
          </span>
        </button>

        {/* Desktop nav (>= md) */}
        <nav className="hidden md:flex items-center gap-1 flex-wrap justify-end">
          <button
            onClick={() => setView("home")}
            className={`${tabBase} ${
              view === "home" ? "text-yellow-400" : "text-neutral-400 hover:text-white"
            }`}
            data-testid="nav-home"
          >
            Início
          </button>
          {authed ? (
            <>
              <button
                onClick={() => setView("clientes")}
                className={`${tabBase} ${
                  view === "clientes"
                    ? "text-yellow-400"
                    : "text-neutral-400 hover:text-white"
                }`}
                data-testid="nav-clientes"
              >
                Clientes
              </button>
              <button
                onClick={() => setView("agenda")}
                className={`${tabBase} ${
                  view === "agenda"
                    ? "text-yellow-400"
                    : "text-neutral-400 hover:text-white"
                }`}
                data-testid="nav-agenda"
              >
                Agenda
              </button>
              <button
                onClick={() => setView("leads")}
                className={`${tabBase} ${
                  view === "leads"
                    ? "text-yellow-400"
                    : "text-neutral-400 hover:text-white"
                }`}
                data-testid="nav-leads"
              >
                Contactos
              </button>
              <button
                onClick={() => setView("reviews-admin")}
                className={`${tabBase} ${
                  view === "reviews-admin"
                    ? "text-yellow-400"
                    : "text-neutral-400 hover:text-white"
                }`}
                data-testid="nav-reviews-admin"
              >
                Avaliações
              </button>
            </>
          ) : null}
          <button
            onClick={() => setView("galeria")}
            className={`${tabBase} ${
              view === "galeria"
                ? "text-yellow-400"
                : "text-neutral-400 hover:text-white"
            }`}
            data-testid="nav-galeria"
          >
            Galeria
          </button>
          <button
            onClick={onPricingClick}
            className={`${tabBase} text-neutral-400 hover:text-white`}
            data-testid="nav-precario"
          >
            Preçário
          </button>
          <button
            onClick={onContactClick}
            className={`${tabBase} text-neutral-400 hover:text-white`}
            data-testid="nav-contacto"
          >
            Contacto
          </button>
          {authed ? (
            <>
              <button
                onClick={onHistoryClick}
                className="btn-ghost text-xs flex items-center gap-2 ml-2"
                data-testid="header-history-btn"
              >
                <History size={14} /> Histórico
              </button>
              <button
                onClick={logout}
                className="btn-ghost text-xs flex items-center gap-2 ml-1 border-yellow-400/30 text-yellow-300 hover:text-yellow-400"
                data-testid="header-logout-btn"
                title="Terminar sessão"
              >
                <LogOut size={14} />
              </button>
            </>
          ) : (
            <button
              onClick={onLoginClick}
              className="btn-ghost text-xs flex items-center gap-2 ml-2 border-yellow-400/30 text-yellow-300 hover:text-yellow-400"
              data-testid="header-login-btn"
            >
              <LogIn size={14} /> Área Reservada
            </button>
          )}
        </nav>

        {/* Mobile burger button (< md) */}
        <button
          className="md:hidden inline-flex items-center gap-2 px-3 py-2 border border-yellow-400/40 text-yellow-300 hover:text-yellow-400"
          onClick={() => setMenuOpen(true)}
          data-testid="nav-mobile-burger"
          aria-label="Abrir menu"
        >
          <Menu size={20} />
          <span className="text-[11px] uppercase tracking-widest font-bold">Menu</span>
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen ? (
        <div
          className="md:hidden fixed inset-0 z-50 bg-black/85 backdrop-blur-sm"
          onClick={closeMenu}
          data-testid="nav-mobile-drawer-backdrop"
        >
          <div
            className="absolute right-0 top-0 h-full w-[82%] max-w-sm bg-[#050505] border-l border-neutral-800 shadow-2xl flex flex-col"
            onClick={(e) => e.stopPropagation()}
            data-testid="nav-mobile-drawer"
          >
            <div className="flex items-center justify-between p-5 border-b border-neutral-900">
              <span className="font-display text-xl uppercase tracking-tight">
                <span className="text-yellow-400">Menu</span>
              </span>
              <button
                className="p-2 text-neutral-400 hover:text-yellow-400"
                onClick={closeMenu}
                data-testid="nav-mobile-close"
                aria-label="Fechar menu"
              >
                <XIcon size={22} />
              </button>
            </div>

            <nav className="flex-1 overflow-y-auto py-4">
              <MobileLink active={view === "home"} onClick={() => go("home")} testid="nav-mobile-home">
                Início
              </MobileLink>

              {authed ? (
                <>
                  <MobileSection>Área Reservada</MobileSection>
                  <MobileLink active={view === "clientes"} onClick={() => go("clientes")} testid="nav-mobile-clientes">
                    Clientes
                  </MobileLink>
                  <MobileLink active={view === "agenda"} onClick={() => go("agenda")} testid="nav-mobile-agenda">
                    Agenda
                  </MobileLink>
                  <MobileLink active={view === "leads"} onClick={() => go("leads")} testid="nav-mobile-leads">
                    Contactos recebidos
                  </MobileLink>
                  <MobileLink active={view === "reviews-admin"} onClick={() => go("reviews-admin")} testid="nav-mobile-reviews-admin">
                    Avaliações
                  </MobileLink>
                  <MobileLink onClick={goHistory} testid="nav-mobile-history">
                    Histórico de treinos
                  </MobileLink>
                </>
              ) : null}

              <MobileSection>Site público</MobileSection>
              <MobileLink active={view === "galeria"} onClick={() => go("galeria")} testid="nav-mobile-galeria">
                Galeria
              </MobileLink>
              <MobileLink onClick={goPricing} testid="nav-mobile-precario">
                Preçário
              </MobileLink>
              <MobileLink onClick={goContact} testid="nav-mobile-contacto">
                Contacto
              </MobileLink>
            </nav>

            <div className="p-5 border-t border-neutral-900">
              {authed ? (
                <button
                  onClick={doLogout}
                  className="btn-ghost w-full inline-flex items-center justify-center gap-2 border-yellow-400/30 text-yellow-300"
                  data-testid="nav-mobile-logout"
                >
                  <LogOut size={14} /> Terminar sessão
                </button>
              ) : (
                <button
                  onClick={doLogin}
                  className="btn-primary w-full inline-flex items-center justify-center gap-2"
                  data-testid="nav-mobile-login"
                >
                  <LogIn size={14} /> Área Reservada
                </button>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}

function MobileSection({ children }) {
  return (
    <div className="px-6 pt-5 pb-2 text-[10px] uppercase tracking-widest text-yellow-400/70 font-bold">
      {children}
    </div>
  );
}

function MobileLink({ children, onClick, active, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`w-full text-left px-6 py-3 text-sm font-bold uppercase tracking-widest border-l-2 transition-colors ${
        active
          ? "border-yellow-400 text-yellow-400 bg-yellow-400/5"
          : "border-transparent text-neutral-300 hover:text-yellow-400 hover:bg-neutral-900/40"
      }`}
    >
      {children}
    </button>
  );
}

function Hero({ onCta, onTour, authed }) {
  const heroBg =
    "https://customer-assets.emergentagent.com/job_personal-trainer-109/artifacts/0kep2k5d_MVIMG_20260324_182450.jpg";
  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${heroBg})`,
          filter: "brightness(0.30) saturate(1.05)",
        }}
        aria-hidden="true"
        data-testid="hero-bg-image"
      />
      {/* Overlays para legibilidade */}
      <div className="absolute inset-0 bg-black/30" aria-hidden="true" />
      <div
        className="absolute inset-0"
        aria-hidden="true"
        style={{
          background:
            "linear-gradient(90deg, rgba(5,5,5,0.85) 0%, rgba(5,5,5,0.35) 45%, rgba(5,5,5,0.05) 100%)",
        }}
      />
      <div
        className="absolute inset-x-0 bottom-0 h-40 pointer-events-none"
        aria-hidden="true"
        style={{
          background:
            "linear-gradient(180deg, rgba(5,5,5,0) 0%, rgba(5,5,5,1) 100%)",
        }}
      />

      <div className="relative px-6 md:px-12 lg:px-24 pt-16 md:pt-24 pb-12 md:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-end">
          <div className="md:col-span-9">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-yellow-400" />
              <span className="overline">Estúdio Premium · Atendimento Exclusivo</span>
            </div>
            <h1
              className="font-display uppercase leading-[0.85] text-[14vw] md:text-[8.5vw] tracking-tighter drop-shadow-[0_4px_24px_rgba(0,0,0,0.8)]"
              data-testid="hero-heading"
            >
              <span className="text-yellow-400">O</span>-MEU-PT<span className="text-yellow-400">.PT</span>
            </h1>
            <p className="mt-8 max-w-2xl text-neutral-100 text-base md:text-lg leading-relaxed drop-shadow-[0_2px_12px_rgba(0,0,0,0.9)]">
              O teu estúdio premium de treino personalizado, com um atendimento
              único e exclusivo num ambiente adequado às tuas limitações,
              condição física e aos teus objetivos.
            </p>
            <p className="mt-3 max-w-2xl text-neutral-300 text-sm md:text-base leading-relaxed drop-shadow-[0_2px_12px_rgba(0,0,0,0.9)]">
              Duas zonas de treino · Interior 45 m² · Exterior 20 m² · Equipamento premium.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <button
                onClick={onCta}
                className="btn-primary inline-flex items-center gap-2"
                data-testid="hero-cta-generate"
              >
                {authed ? "Gerar treino agora" : "Pedir sessão experimental"} <ArrowRight size={18} />
              </button>
              <button
                onClick={authed ? onCta : () => document.querySelector('[data-testid="nav-precario"]')?.click()}
                className="btn-ghost inline-flex items-center gap-2 bg-black/40 backdrop-blur-sm"
                data-testid="hero-cta-learn"
              >
                {authed ? "Ver como funciona" : "Ver preçário"}
              </button>
              {onTour && !authed ? (
                <button
                  onClick={onTour}
                  className="btn-ghost inline-flex items-center gap-2 bg-black/40 backdrop-blur-sm border-yellow-400/40 text-yellow-300 hover:text-yellow-400"
                  data-testid="hero-cta-tour"
                >
                  ▶ Tour Virtual
                </button>
              ) : null}
            </div>
          </div>
          <div className="md:col-span-3 hidden md:flex flex-col items-end gap-6 pb-4">
            <div className="card p-5 w-full bg-black/70 backdrop-blur-md border-neutral-700">
              <div className="overline mb-2">Interior · 45 m²</div>
              <div className="text-sm text-neutral-200">
                Smith machine, poleia dupla, passadeira, air bike, spin bike e mais.
              </div>
            </div>
            <div className="card p-5 w-full bg-black/70 backdrop-blur-md border-neutral-700">
              <div className="overline mb-2">Exterior · 20 m²</div>
              <div className="text-sm text-neutral-200">
                Kettlebells, TRX, battle rope, escada de agilidade e bolas medicinais.
              </div>
            </div>
            <div className="card p-5 w-full bg-black/70 backdrop-blur-md border-neutral-700">
              <div className="overline mb-2">15-90 min</div>
              <div className="text-sm text-neutral-200">
                Adapta o treino ao tempo que tens hoje.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ChipGroup({ items, value, onChange, testidPrefix }) {
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((it) => {
        const Icon = it.icon;
        const active = value === it.id;
        return (
          <button
            key={it.id}
            type="button"
            className="chip"
            data-active={active}
            data-testid={`${testidPrefix}-${it.id}`}
            onClick={() => onChange(it.id)}
          >
            {Icon ? <Icon size={14} /> : null}
            {it.label}
          </button>
        );
      })}
    </div>
  );
}

function TrainerSection() {
  const trainerPhoto =
    "https://customer-assets.emergentagent.com/job_personal-trainer-109/artifacts/pyyxicvz_1779139386644.jpg";
  const bg =
    "https://customer-assets.emergentagent.com/job_personal-trainer-109/artifacts/u95wwx32_IMG_20260504_142859.jpg";
  return (
    <section
      id="treinador"
      className="px-6 md:px-12 lg:px-24 py-16 md:py-24 border-t border-neutral-900 relative overflow-hidden"
      data-testid="trainer-section"
    >
      <div
        className="absolute inset-0 bg-cover bg-center md:bg-fixed"
        style={{ backgroundImage: `url(${bg})`, filter: "brightness(0.30)" }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-black/65" aria-hidden="true" />
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center relative">
        <div className="md:col-span-5 lg:col-span-4 relative">
          <div className="relative aspect-square w-full max-w-md">
            <div className="absolute -top-3 -left-3 w-24 h-24 border-l-2 border-t-2 border-yellow-400 pointer-events-none" />
            <div className="absolute -bottom-3 -right-3 w-24 h-24 border-r-2 border-b-2 border-yellow-400 pointer-events-none" />
            <img
              src={trainerPhoto}
              alt="Pedro Pando — CEO e Personal Trainer do estúdio O-meu-Pt.pt"
              className="w-full h-full object-cover grayscale-[0.15] contrast-[1.05]"
              data-testid="trainer-photo"
              loading="lazy"
            />
          </div>
        </div>

        <div className="md:col-span-7 lg:col-span-8">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-10 bg-yellow-400" />
            <span className="overline">Quem está por trás · Founder</span>
          </div>
          <h2
            className="font-display uppercase text-5xl md:text-7xl tracking-tighter leading-[0.9] drop-shadow-[0_3px_18px_rgba(0,0,0,0.85)]"
            data-testid="trainer-name"
          >
            PEDRO<br />
            <span className="text-yellow-400">PANDO.</span>
          </h2>

          <div className="mt-6 flex flex-wrap gap-2">
            <span className="chip" data-active="true">CEO</span>
            <span className="chip">Personal Trainer Certificado</span>
            <span className="chip">Fundador do Estúdio</span>
          </div>

          <p className="mt-8 max-w-2xl text-neutral-200 text-base md:text-lg leading-relaxed drop-shadow-[0_2px_10px_rgba(0,0,0,0.9)]">
            CEO e personal trainer do estúdio O-meu-Pt.pt. Criou este espaço
            premium com uma filosofia simples: cada cliente é único, cada plano
            é desenhado à medida, e cada sessão acontece num ambiente exclusivo
            com a tua playlist a tocar, sem distrações, sem multidões, só tu, o
            teu foco e dedicação rumo aos teus objetivos.
          </p>
          <p className="mt-4 max-w-2xl text-neutral-300 text-sm md:text-base leading-relaxed drop-shadow-[0_2px_10px_rgba(0,0,0,0.9)]">
            Mais de duas décadas a acompanhar pessoas reais — desde iniciantes a
            atletas, jovens em formação desportiva, reabilitação e treino pré e
            pós-parto — sempre com atenção total à condição física, limitações e
            objetivos de cada um.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
            <div className="border border-neutral-700 bg-black/60 backdrop-blur-sm p-4">
              <div className="font-display text-3xl text-yellow-400">20+</div>
              <div className="text-[11px] uppercase tracking-widest text-neutral-400 mt-1">
                Anos de Experiência
              </div>
            </div>
            <div className="border border-neutral-700 bg-black/60 backdrop-blur-sm p-4">
              <div className="font-display text-3xl text-yellow-400">1:1</div>
              <div className="text-[11px] uppercase tracking-widest text-neutral-400 mt-1">
                Atendimento Exclusivo
              </div>
            </div>
            <div className="border border-neutral-700 bg-black/60 backdrop-blur-sm p-4">
              <div className="font-display text-3xl text-yellow-400">2</div>
              <div className="text-[11px] uppercase tracking-widest text-neutral-400 mt-1">
                Zonas de Treino
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function PricingSection() {
  const [discount, setDiscount] = useState(false);
  const DISCOUNT_PCT = 15;
  const applyDiscount = (v) =>
    discount ? Math.round(v * (1 - DISCOUNT_PCT / 100) * 100) / 100 : v;

  const plans = [
    {
      id: "individual",
      label: "Individual",
      subtitle: "Atendimento exclusivo 1:1",
      icon: User,
      duracao: "40 min",
      packs: [
        { freq: "1 treino / semana", min: "Mín. 4 treinos por mês", preco: 100 },
        { freq: "2 treinos / semana", min: "Mín. 8 treinos por mês", preco: 170 },
        { freq: "3 treinos / semana", min: "Mín. 12 treinos por mês", preco: 240 },
      ],
    },
    {
      id: "duo",
      label: "Duo",
      subtitle: "2 pessoas em simultâneo",
      icon: Users,
      duracao: "50 min",
      packs: [
        { freq: "2 treinos / semana", min: "Mín. 8 treinos por mês", preco: 280 },
        { freq: "3 treinos / semana", min: "Mín. 12 treinos por mês", preco: 380 },
      ],
      destaque: true,
    },
    {
      id: "trio",
      label: "Trio",
      subtitle: "3 pessoas em simultâneo",
      icon: UsersRound,
      duracao: "60 min",
      packs: [
        { freq: "2 treinos / semana", min: "Mín. 8 treinos por mês", preco: 350 },
        { freq: "3 treinos / semana", min: "Mín. 12 treinos por mês", preco: 480 },
      ],
    },
  ];

  return (
    <section
      id="precario"
      className="px-6 md:px-12 lg:px-24 py-16 md:py-24 border-t border-neutral-900 relative overflow-hidden"
      data-testid="pricing-section"
    >
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4 relative">
        <div>
          <div className="overline mb-3">Preçário · Setembro 2025</div>
          <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tighter leading-[0.9]">
            TREINO<br />
            <span className="text-yellow-400">PERSONALIZADO.</span>
          </h2>
        </div>
        <div className="max-w-md text-neutral-400 text-sm md:text-base leading-relaxed">
          Escolhe o pack adequado ao teu ritmo. Todos os packs têm validade de 1 mês
          com renovação automática no 1.º dia útil do mês seguinte.
        </div>
      </div>

      {/* Botão de Campanha */}
      <button
        type="button"
        onClick={() => setDiscount((d) => !d)}
        className={`w-full mb-8 border-2 ${
          discount
            ? "border-yellow-400 bg-yellow-400 text-black"
            : "border-yellow-400/60 bg-yellow-400/[0.06] text-yellow-400 hover:bg-yellow-400/10"
        } px-5 md:px-7 py-4 md:py-5 flex flex-wrap items-center justify-between gap-4 transition-colors`}
        data-testid="campaign-toggle-btn"
      >
        <div className="flex items-center gap-3">
          <Tag size={22} className={discount ? "text-black" : "text-yellow-400"} />
          <div className="text-left">
            <div className="font-display text-xl md:text-2xl uppercase tracking-tighter leading-none">
              Campanha em vigor · 15% OFF
            </div>
            <div className="text-[11px] uppercase tracking-widest mt-1 opacity-80">
              {discount
                ? "Desconto APLICADO · clica para remover"
                : "Clica para ver os preços com desconto"}
            </div>
          </div>
        </div>
        <div
          className={`px-4 py-2 text-xs uppercase tracking-widest font-bold ${
            discount ? "bg-black text-yellow-400" : "bg-yellow-400 text-black"
          }`}
        >
          {discount ? "Ativo" : "Ativar"}
        </div>
      </button>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 relative">
        {plans.map((p) => {
          const Icon = p.icon;
          return (
            <div
              key={p.id}
              className={`relative border ${
                p.destaque
                  ? "border-yellow-400 bg-yellow-400/[0.04]"
                  : "border-neutral-800 bg-neutral-950/40"
              } p-7 flex flex-col`}
              data-testid={`pricing-card-${p.id}`}
            >
              {p.destaque ? (
                <div className="absolute -top-3 left-7 bg-yellow-400 text-black text-[10px] uppercase tracking-widest font-bold px-3 py-1">
                  Mais popular
                </div>
              ) : null}
              {discount ? (
                <div className="absolute -top-3 right-7 bg-black border border-yellow-400 text-yellow-400 text-[10px] uppercase tracking-widest font-bold px-3 py-1">
                  -15%
                </div>
              ) : null}

              <div className="flex items-center gap-3 mb-2">
                <Icon size={20} className="text-yellow-400" />
                <span className="overline">Pack {p.label}</span>
              </div>
              <h3 className="font-display text-4xl md:text-5xl uppercase tracking-tighter">
                {p.label.toUpperCase()}
              </h3>
              <div className="text-sm text-neutral-400 mt-1">{p.subtitle}</div>
              <div className="text-xs text-neutral-500 mt-1 uppercase tracking-widest">
                Sessões de {p.duracao}
              </div>

              <div className="mt-8 space-y-5">
                {p.packs.map((pk, i) => {
                  const finalPrice = applyDiscount(pk.preco);
                  return (
                    <div
                      key={i}
                      className="border-t border-neutral-800 pt-5 flex items-end justify-between gap-3"
                    >
                      <div className="flex-1">
                        <div className="text-sm font-medium text-white">
                          {pk.freq}
                        </div>
                        <div className="text-[11px] text-neutral-500 uppercase tracking-widest mt-1">
                          {pk.min}
                        </div>
                      </div>
                      <div className="text-right">
                        {discount ? (
                          <div className="text-xs text-neutral-500 line-through leading-none">
                            {pk.preco}€
                          </div>
                        ) : null}
                        <div className="font-display text-3xl md:text-4xl text-yellow-400 leading-none mt-1">
                          {finalPrice.toFixed(discount ? 2 : 0)}
                          <span className="text-xl">€</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="mt-8 text-[11px] uppercase tracking-widest text-neutral-500 flex items-center gap-2">
                <ShieldCheck size={14} className="text-yellow-400" />
                + 10 € seguro anual individual
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-10 border border-yellow-400/30 bg-gradient-to-br from-yellow-400/[0.06] to-transparent p-6 md:p-8" data-testid="perks-box">
        <div className="flex items-center gap-3 mb-5">
          <div className="h-px w-10 bg-yellow-400" />
          <span className="overline">Incluído em todas as sessões</span>
        </div>
        <p className="text-base md:text-lg text-neutral-200 leading-relaxed mb-6 max-w-3xl">
          Em todas as sessões oferecemos <strong className="text-white">toalha de treino</strong>,
          <strong className="text-white"> café</strong>, <strong className="text-white">garrafa de água fresca ou natural</strong> e
          a tua <strong className="text-white">playlist favorita a tocar</strong> enquanto treinas.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: Sparkle, label: "Toalha de treino", sub: "Em cada sessão" },
            { icon: Coffee, label: "Café cortesia", sub: "Antes ou depois" },
            { icon: Droplets, label: "Água fresca ou natural", sub: "Sempre disponível" },
            { icon: Music, label: "A tua playlist", sub: "A tocar para ti" },
          ].map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={i}
                className="border border-neutral-800 bg-black/40 p-4 flex items-start gap-3"
                data-testid={`perk-${i}`}
              >
                <Icon size={22} className="text-yellow-400 mt-0.5 shrink-0" />
                <div className="min-w-0">
                  <div className="text-sm font-bold uppercase tracking-wider text-white truncate">
                    {p.label}
                  </div>
                  <div className="text-[11px] text-neutral-500 uppercase tracking-widest mt-0.5">
                    {p.sub}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mt-6 border border-neutral-800 bg-neutral-950/60 p-5 md:p-6 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-start gap-3 max-w-2xl">
          <Repeat size={18} className="text-yellow-400 mt-0.5 shrink-0" />
          <div className="text-sm text-neutral-300 leading-relaxed">
            <strong className="text-white">Renovação automática.</strong> Todos os
            packs têm validade de 1 mês e são renovados automaticamente no
            1.º dia útil do mês seguinte. Acresce 10 € de seguro anual individual.
          </div>
        </div>
        <div className="text-[11px] uppercase tracking-widest text-neutral-500">
          Tabela em vigor desde 01 Setembro 2025
        </div>
      </div>

      {/* Comparador visual: preço por pessoa por treino */}
      <PriceComparator discount={discount} discountPct={DISCOUNT_PCT} />

      <div className="mt-10 flex flex-wrap items-center gap-2 text-sm text-neutral-400">
        <span className="text-yellow-400 font-bold uppercase tracking-widest text-xs">
          #estamosjuntos
        </span>
        <span>rumo aos vossos objetivos.</span>
      </div>
    </section>
  );
}

function PriceComparator({ discount = false, discountPct = 0 }) {
  const [freq, setFreq] = useState("2x"); // "2x" ou "3x"
  const factor = discount ? 1 - discountPct / 100 : 1;

  // 1x/semana = 4 treinos/mês · 2x/semana = 8 · 3x/semana = 12
  const data = {
    "1x": {
      treinos: 4,
      label: "1 treino / semana · 4 treinos/mês",
      packs: [
        { id: "individual", label: "Individual", total: 100, pessoas: 1, duracao: 40 },
      ],
    },
    "2x": {
      treinos: 8,
      label: "2 treinos / semana · 8 treinos/mês",
      packs: [
        { id: "individual", label: "Individual", total: 170, pessoas: 1, duracao: 40 },
        { id: "duo", label: "Duo", total: 280, pessoas: 2, duracao: 50 },
        { id: "trio", label: "Trio", total: 350, pessoas: 3, duracao: 60 },
      ],
    },
    "3x": {
      treinos: 12,
      label: "3 treinos / semana · 12 treinos/mês",
      packs: [
        { id: "individual", label: "Individual", total: 240, pessoas: 1, duracao: 40 },
        { id: "duo", label: "Duo", total: 380, pessoas: 2, duracao: 50 },
        { id: "trio", label: "Trio", total: 480, pessoas: 3, duracao: 60 },
      ],
    },
  };

  const current = data[freq];
  // Calcular preço por pessoa por treino (com possível desconto)
  const rows = current.packs.map((p) => {
    const totalFinal = p.total * factor;
    return {
      ...p,
      totalFinal,
      totalOriginal: p.total,
      porPessoa: totalFinal / p.pessoas,
      porTreinoPessoa: totalFinal / p.pessoas / current.treinos,
    };
  });
  const minPrice = Math.min(...rows.map((r) => r.porTreinoPessoa));
  const maxPrice = Math.max(...rows.map((r) => r.porTreinoPessoa));
  const range = maxPrice - minPrice || 1;

  return (
    <div className="mt-12 border border-yellow-400/30 bg-yellow-400/[0.03] p-6 md:p-8" data-testid="price-comparator">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <div className="overline mb-2 flex items-center gap-2">
            Comparador · Custo por Treino
            {discount ? (
              <span className="bg-yellow-400 text-black px-2 py-0.5 text-[10px] font-bold">
                -15% APLICADO
              </span>
            ) : null}
          </div>
          <h3 className="font-display text-3xl md:text-4xl uppercase tracking-tighter">
            Quanto pagas <span className="text-yellow-400">por treino</span>?
          </h3>
          <div className="text-sm text-neutral-400 mt-2">
            Valor por <strong className="text-white">pessoa</strong> e por sessão — mostra-te o real valor do treino em duo ou trio.
          </div>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            className="chip"
            data-active={freq === "1x"}
            onClick={() => setFreq("1x")}
            data-testid="comparator-freq-1x"
          >
            1x / semana
          </button>
          <button
            type="button"
            className="chip"
            data-active={freq === "2x"}
            onClick={() => setFreq("2x")}
            data-testid="comparator-freq-2x"
          >
            2x / semana
          </button>
          <button
            type="button"
            className="chip"
            data-active={freq === "3x"}
            onClick={() => setFreq("3x")}
            data-testid="comparator-freq-3x"
          >
            3x / semana
          </button>
        </div>
      </div>

      <div className="text-[11px] uppercase tracking-widest text-neutral-500 mb-4">
        Base: {current.label}
      </div>

      <div className="space-y-4">
        {rows.map((r) => {
          const widthPct = 30 + ((r.porTreinoPessoa - minPrice) / range) * 70 || 100;
          const isBest = r.porTreinoPessoa === minPrice;
          return (
            <div
              key={r.id}
              className="grid grid-cols-12 gap-4 items-center"
              data-testid={`comparator-row-${r.id}`}
            >
              <div className="col-span-3 md:col-span-2">
                <div className="font-display uppercase text-lg tracking-tight">
                  {r.label}
                </div>
                <div className="text-[10px] uppercase tracking-widest text-neutral-500">
                  {r.pessoas}p · {r.duracao}m
                </div>
              </div>
              <div className="col-span-6 md:col-span-7">
                <div className="relative h-10 bg-neutral-950 border border-neutral-900 overflow-hidden">
                  <div
                    className={`h-full transition-all duration-500 ${
                      isBest ? "bg-yellow-400" : "bg-neutral-700"
                    }`}
                    style={{ width: `${widthPct}%` }}
                  />
                  <div className="absolute inset-0 flex items-center px-3 text-xs font-bold uppercase tracking-widest">
                    {r.porTreinoPessoa.toFixed(2)} € / treino
                  </div>
                </div>
              </div>
              <div className="col-span-3 text-right">
                <div className="text-[10px] uppercase tracking-widest text-neutral-500">
                  Total pack
                </div>
                {discount ? (
                  <div className="text-[11px] text-neutral-500 line-through">
                    {r.totalOriginal}€
                  </div>
                ) : null}
                <div className="font-display text-2xl text-white">
                  {r.totalFinal.toFixed(discount ? 2 : 0)}
                  <span className="text-base text-neutral-500">€</span>
                </div>
                <div className="text-[10px] uppercase tracking-widest text-neutral-500 mt-0.5">
                  {r.porPessoa.toFixed(discount ? 2 : 0)}€/pessoa
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 flex items-start gap-3 text-sm text-neutral-300 border-t border-neutral-800 pt-5">
        <Euro size={16} className="text-yellow-400 mt-0.5 shrink-0" />
        <div className="leading-relaxed">
          {rows.length >= 2 ? (
            <>
              <strong className="text-white">Conclusão:</strong> treinar em{" "}
              <span className="text-yellow-400 font-bold">{rows[rows.length - 1].label.toLowerCase()}</span>{" "}
              custa até{" "}
              {(
                ((rows[0].porTreinoPessoa - rows[rows.length - 1].porTreinoPessoa) /
                  rows[0].porTreinoPessoa) *
                100
              ).toFixed(0)}
              % menos por pessoa do que treinar em individual, mantendo o
              atendimento personalizado do Pedro.
            </>
          ) : (
            <>
              <strong className="text-white">Pack arranque:</strong> ideal para começares no teu ritmo, com 4 sessões mensais 1:1 totalmente personalizadas.
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function SectionBackground({ url, brightness = 0.30, overlay = 0.78 }) {
  return (
    <>
      <div
        className="absolute inset-0 bg-cover bg-center md:bg-fixed pointer-events-none"
        style={{ backgroundImage: `url(${url})`, filter: `brightness(${brightness})` }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: `rgba(5,5,5,${overlay})` }}
        aria-hidden="true"
      />
    </>
  );
}

function FiltersForm({ form, setForm, onGenerate, loading }) {
  return (
    <section
      id="parametros"
      className="px-6 md:px-12 lg:px-24 py-12 md:py-16 border-t border-neutral-900 relative overflow-hidden"
    >
      <SectionBackground
        url="https://customer-assets.emergentagent.com/job_personal-trainer-109/artifacts/p8t20inm_IMG_20260504_142758.jpg"
        brightness={0.30}
        overlay={0.8}
      />
      <div className="relative">
      <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
        <div>
          <div className="overline mb-3">01 / Parâmetros</div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-tighter">
            Define o teu treino
          </h2>
        </div>
        <div className="text-neutral-500 text-sm max-w-md">
          Quatro inputs. Um plano à medida. Escolhe e dá o passo seguinte.
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="card p-6 md:p-8">
          <div className="overline mb-4">Objetivo</div>
          <ChipGroup
            items={OBJETIVOS}
            value={form.objetivo}
            onChange={(v) => setForm({ ...form, objetivo: v })}
            testidPrefix="objetivo"
          />
        </div>

        <div className="card p-6 md:p-8">
          <div className="overline mb-4">Nível</div>
          <ChipGroup
            items={NIVEIS}
            value={form.nivel}
            onChange={(v) => setForm({ ...form, nivel: v })}
            testidPrefix="nivel"
          />
        </div>

        <div className="card p-6 md:p-8">
          <div className="overline mb-4">Zona de treino</div>
          <ChipGroup
            items={ZONAS}
            value={form.zona}
            onChange={(v) => setForm({ ...form, zona: v })}
            testidPrefix="zona"
          />
        </div>

        <div className="card p-6 md:p-8">
          <div className="flex items-center justify-between mb-4">
            <div className="overline">Duração</div>
            <div
              className="font-display text-3xl text-yellow-400"
              data-testid="duracao-value"
            >
              {form.duracao}
              <span className="text-sm text-neutral-500 ml-1">min</span>
            </div>
          </div>
          <input
            type="range"
            min={15}
            max={90}
            step={5}
            value={form.duracao}
            onChange={(e) =>
              setForm({ ...form, duracao: parseInt(e.target.value, 10) })
            }
            className="range-yellow"
            data-testid="duracao-range"
          />
          <div className="flex justify-between text-xs text-neutral-600 mt-2">
            <span>15</span>
            <span>30</span>
            <span>45</span>
            <span>60</span>
            <span>75</span>
            <span>90</span>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <div className="card p-6 md:p-8">
          <label className="overline mb-3 block">Foco específico (opcional)</label>
          <input
            type="text"
            placeholder="Ex.: peito e tríceps, pernas, corpo todo, abdominais..."
            value={form.foco}
            onChange={(e) => setForm({ ...form, foco: e.target.value })}
            className="field"
            data-testid="foco-input"
          />
        </div>
      </div>

      <div className="mt-10 flex flex-wrap items-center gap-4">
        <button
          onClick={onGenerate}
          disabled={loading}
          className="btn-primary inline-flex items-center gap-3"
          data-testid="generate-workout-btn"
        >
          {loading ? (
            <>
              <Loader2 className="animate-spin" size={18} /> A gerar...
            </>
          ) : (
            <>
              <Sparkles size={18} /> Gerar plano com IA
            </>
          )}
        </button>
        <span className="text-sm text-neutral-400">
          Powered by Claude Sonnet 4.5
        </span>
      </div>
      </div>
    </section>
  );
}

function ExerciseVideo({ nome }) {
  const query = encodeURIComponent(`${nome} demonstração exercício`);
  const url = `https://www.youtube.com/results?search_query=${query}`;
  // Thumb via YouTube/Vimeo wouldn't be available without API; use a stylized poster
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full aspect-video bg-neutral-950 border border-neutral-900 hover:border-yellow-400/60 transition-colors relative group overflow-hidden"
      data-testid="exercise-video"
      title={`Ver vídeo: ${nome}`}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-neutral-900 via-black to-neutral-950" />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-3">
        <div className="w-12 h-12 rounded-full bg-yellow-400 text-black flex items-center justify-center mb-2 group-hover:scale-110 transition-transform">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
        <div className="text-[10px] uppercase tracking-widest font-bold text-yellow-400">
          Ver vídeo
        </div>
        <div className="text-[10px] text-neutral-500 mt-0.5">YouTube</div>
      </div>
    </a>
  );
}

function WorkoutResult({ plan, request, onSave, saved }) {
  if (!plan) return null;
  return (
    <section
      className="px-6 md:px-12 lg:px-24 py-12 md:py-20 border-t border-neutral-900 anim-slide relative overflow-hidden"
      data-testid="workout-result-section"
    >
      <SectionBackground
        url="https://customer-assets.emergentagent.com/job_personal-trainer-109/artifacts/g7f55e44_IMG_20260504_142812.jpg"
        brightness={0.30}
        overlay={0.82}
      />
      <div className="relative">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-10">
        <div className="md:col-span-8">
          <div className="overline mb-3">02 / O teu plano</div>
          <h2
            className="font-display text-4xl md:text-6xl uppercase tracking-tighter"
            data-testid="workout-title"
          >
            {plan.titulo}
          </h2>
          <div className="flex flex-wrap gap-2 mt-5">
            <span className="chip" data-active="true">
              {labelObjetivo(request.objetivo)}
            </span>
            <span className="chip">{labelNivel(request.nivel)}</span>
            <span className="chip">{labelZona(request.zona)}</span>
            <span className="chip">
              <Clock size={12} /> {plan.duracao_estimada_min} min
            </span>
          </div>
        </div>
        <div className="md:col-span-4 flex md:justify-end items-start">
          <button
            onClick={onSave}
            disabled={saved}
            className="btn-primary inline-flex items-center gap-2"
            data-testid="save-workout-btn"
          >
            <Save size={16} /> {saved ? "Guardado" : "Guardar treino"}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <aside className="lg:col-span-4 space-y-6">
          <div className="card p-6">
            <div className="overline mb-3">Aquecimento</div>
            <ul className="space-y-2 text-sm text-neutral-300">
              {(plan.aquecimento || []).map((a, i) => (
                <li key={i} className="flex gap-3">
                  <span className="text-yellow-400 font-display">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{a}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="card p-6">
            <div className="overline mb-3">Alongamento final</div>
            <ul className="space-y-2 text-sm text-neutral-300">
              {(plan.alongamento || []).map((a, i) => (
                <li key={i} className="flex gap-3">
                  <span className="text-yellow-400 font-display">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{a}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="card p-6">
            <div className="overline mb-3">Dicas do treinador</div>
            <ul className="space-y-3 text-sm text-neutral-300">
              {(plan.dicas || []).map((d, i) => (
                <li key={i} className="flex gap-3">
                  <span className="text-yellow-400">→</span>
                  <span>{d}</span>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <div className="lg:col-span-8">
          <div className="overline mb-4">Exercícios principais</div>
          <ul className="divide-y divide-neutral-900 border-y border-neutral-900">
            {(plan.exercicios || []).map((ex, i) => (
              <li
                key={i}
                className="py-5 grid grid-cols-12 gap-4 items-start"
                data-testid={`exercise-row-${i}`}
              >
                <div className="col-span-2 md:col-span-1 font-display text-yellow-400 text-2xl">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="col-span-10 md:col-span-3">
                  <ExerciseVideo nome={ex.nome} />
                </div>
                <div className="col-span-12 md:col-span-4">
                  <div className="font-display uppercase text-xl tracking-tight">
                    {ex.nome}
                  </div>
                  {ex.notas ? (
                    <p className="text-sm text-neutral-500 mt-1 leading-relaxed">
                      {ex.notas}
                    </p>
                  ) : null}
                </div>
                <div className="col-span-12 md:col-span-4 grid grid-cols-3 gap-3 text-center">
                  <div className="border border-neutral-900 py-3">
                    <div className="text-[10px] uppercase tracking-widest text-neutral-500">
                      Séries
                    </div>
                    <div className="font-display text-lg text-yellow-400">
                      {ex.series}
                    </div>
                  </div>
                  <div className="border border-neutral-900 py-3">
                    <div className="text-[10px] uppercase tracking-widest text-neutral-500">
                      Reps
                    </div>
                    <div className="font-display text-lg">{ex.repeticoes}</div>
                  </div>
                  <div className="border border-neutral-900 py-3">
                    <div className="text-[10px] uppercase tracking-widest text-neutral-500">
                      Descanso
                    </div>
                    <div className="font-display text-lg">{ex.descanso}</div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      </div>
    </section>
  );
}

function HistorySection({ items, onLoad, onDelete }) {
  return (
    <section
      id="historico"
      className="px-6 md:px-12 lg:px-24 py-12 md:py-20 border-t border-neutral-900 relative overflow-hidden"
      data-testid="history-section"
    >
      <SectionBackground
        url="https://customer-assets.emergentagent.com/job_personal-trainer-109/artifacts/k9kw1rpt_IMG_20260504_142753.jpg"
        brightness={0.30}
        overlay={0.82}
      />
      <div className="relative">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="overline mb-3">03 / Histórico</div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-tighter">
            Treinos anteriores
          </h2>
        </div>
        <div className="text-sm text-neutral-500">
          {items.length === 0 ? "Ainda sem treinos guardados" : `${items.length} guardados`}
        </div>
      </div>

      {items.length === 0 ? (
        <div className="card p-10 text-center">
          <div className="text-neutral-500 mb-2">Sem registos.</div>
          <div className="text-sm text-neutral-600">
            Gera um treino e clica em "Guardar" para o teres aqui.
          </div>
        </div>
      ) : (
        <ul className="divide-y divide-neutral-900 border-y border-neutral-900">
          {items.map((it) => (
            <li
              key={it.id}
              className="py-5 grid grid-cols-12 gap-4 items-center"
              data-testid={`history-row-${it.id}`}
            >
              <div className="col-span-12 md:col-span-5">
                <div className="font-display uppercase text-lg tracking-tight">
                  {it.plan.titulo}
                </div>
                <div className="text-xs text-neutral-500 mt-1">
                  {new Date(it.created_at).toLocaleString("pt-PT")}
                </div>
              </div>
              <div className="col-span-12 md:col-span-4 flex flex-wrap gap-2">
                <span className="chip">{labelObjetivo(it.request.objetivo)}</span>
                <span className="chip">{labelNivel(it.request.nivel)}</span>
                <span className="chip">
                  <Clock size={12} /> {it.plan.duracao_estimada_min}m
                </span>
              </div>
              <div className="col-span-12 md:col-span-3 flex md:justify-end gap-2">
                <button
                  onClick={() => onLoad(it)}
                  className="btn-ghost text-xs"
                  data-testid={`history-load-${it.id}`}
                >
                  Abrir
                </button>
                <button
                  onClick={() => onDelete(it.id)}
                  className="btn-ghost text-xs inline-flex items-center gap-1"
                  data-testid={`history-delete-${it.id}`}
                >
                  <Trash2 size={12} />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="px-6 md:px-12 lg:px-24 py-10 border-t border-neutral-900 text-xs text-neutral-600 flex flex-wrap items-center justify-between gap-3">
      <div>© {new Date().getFullYear()} O-MEU-PT.PT · Forjado em Portugal</div>
      <div className="uppercase tracking-widest">
        Aviso: consulta um profissional antes de iniciar qualquer programa de treino.
      </div>
    </footer>
  );
}

function App() {
  const { authed, ready } = useAuth();
  const [form, setForm] = useState({
    objetivo: "ganho_muscular",
    nivel: "iniciante",
    zona: "interior",
    duracao: 45,
    foco: "",
  });
  const [plan, setPlan] = useState(null);
  const [lastRequest, setLastRequest] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const [history, setHistory] = useState([]);
  const [view, setView] = useState("home"); // "home" | "clientes" | "galeria" | "leads"
  const [loginOpen, setLoginOpen] = useState(false);
  const [tourOpen, setTourOpen] = useState(false);

  const fetchHistory = async () => {
    if (!authed) {
      setHistory([]);
      return;
    }
    try {
      const res = await axios.get(`${API}/workouts/history`);
      setHistory(res.data || []);
    } catch (e) {
      console.error("history error", e);
    }
  };

  useEffect(() => {
    if (ready) fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, authed]);

  // Se a sessão expirar e estavas em rota privada, volta a home
  useEffect(() => {
    if (ready && !authed && (view === "clientes" || view === "leads" || view === "agenda" || view === "reviews-admin")) {
      setView("home");
    }
  }, [ready, authed, view]);

  const handleGenerate = async () => {
    setLoading(true);
    setError("");
    setPlan(null);
    setSaved(false);
    try {
      const payload = { ...form, foco: form.foco || null };
      const res = await axios.post(`${API}/workouts/generate`, payload);
      setPlan(res.data);
      setLastRequest(form);
      setTimeout(() => {
        const el = document.querySelector('[data-testid="workout-result-section"]');
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } catch (e) {
      console.error(e);
      setError(
        e?.response?.data?.detail || "Erro ao gerar o treino. Tenta novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!plan || !lastRequest) return;
    try {
      await axios.post(`${API}/workouts/save`, {
        request: { ...lastRequest, foco: lastRequest.foco || null },
        plan,
      });
      setSaved(true);
      fetchHistory();
    } catch (e) {
      console.error("save error", e);
      setError("Não foi possível guardar o treino.");
    }
  };

  const handleLoadFromHistory = (item) => {
    setPlan(item.plan);
    setLastRequest(item.request);
    setSaved(true);
    setTimeout(() => {
      const el = document.querySelector('[data-testid="workout-result-section"]');
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 50);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API}/workouts/${id}`);
      fetchHistory();
    } catch (e) {
      console.error("delete error", e);
    }
  };

  const scrollToId = (id, delay = 0) => {
    const doScroll = () => {
      const el = document.getElementById(id);
      if (!el) return;
      const headerOffset = 64;
      const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top, behavior: "smooth" });
    };
    if (delay > 0) setTimeout(doScroll, delay);
    else doScroll();
  };

  const scrollToHistory = () => scrollToId("historico");
  const scrollToParametros = () => scrollToId("parametros");

  const handleHistoryClick = () => {
    if (view !== "home") {
      setView("home");
      scrollToId("historico", 250);
    } else {
      scrollToId("historico");
    }
  };

  const handlePricingClick = () => {
    setView("precario");
  };

  const handleContactClick = () => {
    if (view !== "home") {
      setView("home");
      scrollToId("contacto", 250);
    } else {
      scrollToId("contacto");
    }
  };

  return (
    <div className="App">
      <Header
        view={view}
        setView={setView}
        onHistoryClick={handleHistoryClick}
        onPricingClick={handlePricingClick}
        onContactClick={handleContactClick}
        onLoginClick={() => setLoginOpen(true)}
      />
      <LoginModal
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onSuccess={() => setView("clientes")}
      />
      {tourOpen ? <VirtualTour onClose={() => setTourOpen(false)} /> : null}
      {view === "clientes" && authed ? (
        <ClientesView />
      ) : view === "agenda" && authed ? (
        <AgendaView />
      ) : view === "leads" && authed ? (
        <LeadsView />
      ) : view === "reviews-admin" && authed ? (
        <ReviewsAdminView />
      ) : view === "galeria" ? (
        <GaleriaView />
      ) : view === "precario" ? (
        <PricingSection />
      ) : (
        <>
          <PromoBanner onCta={authed ? scrollToParametros : handleContactClick} />
          <Hero
            onCta={authed ? scrollToParametros : handleContactClick}
            onTour={() => setTourOpen(true)}
            authed={authed}
          />
          <PlanosVeraoSection />
          <HyroxSection />
          <TrainerSection />
          <GalleryPreview onSeeAll={() => setView("galeria")} onTour={() => setTourOpen(true)} />
          {authed ? (
            <>
              <FiltersForm
                form={form}
                setForm={setForm}
                onGenerate={handleGenerate}
                loading={loading}
              />
              {error ? (
                <div className="px-6 md:px-12 lg:px-24" data-testid="generate-error">
                  <div className="card p-5 border-yellow-400/40 text-yellow-300 text-sm">
                    {error}
                  </div>
                </div>
              ) : null}
              <WorkoutResult
                plan={plan}
                request={lastRequest}
                onSave={handleSave}
                saved={saved}
              />
              <HistorySection
                items={history}
                onLoad={handleLoadFromHistory}
                onDelete={handleDelete}
              />
            </>
          ) : null}
          <LeadForm />
          <ReviewsSection />
        </>
      )}
      <Footer />
    </div>
  );
}

export default App;
